import { useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Typography,
    TextField,
    Divider
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import BlackList from "../../services/blacklist/Blacklist";
import toast from "react-hot-toast";

const AddContact = (props) => {
    const [open, setOpen] = useState(false);
    const currentUserData = useSelector((state) => state.profile.profile);

    const closeModal = () => {
        setOpen(false);
    };

    const searchSchema = Yup.object().shape({
        Username: Yup.string().required("Cannot be empty"),
        whatsappno: Yup.string().required("Cannot be empty"),
    });

    return (
        <div className="vertically-centered-modal">
            <button
                className="ms-3 btn btn-sm btn-neutral rounded-pill"
                onClick={() => setOpen(true)}
            >
                Add Contact
            </button>

            <Dialog open={open} onClose={closeModal} fullWidth maxWidth="md">
                <DialogTitle
                    sx={{
                        m: 0,
                        p: 2,
                        backgroundColor: "#007bff",
                        color: "white",
                    }}
                >
                    <Typography variant="h5" fontWeight={600}>
                        Add Contact
                    </Typography>
                </DialogTitle>

                <Formik
                    validationSchema={searchSchema}
                    initialValues={{
                        Username: "",
                        whatsappno: "",
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        let data = {
                            contact_name: values.Username,
                            whatsappno: values.whatsappno,
                            user_id: currentUserData?.currentUserData?.result?.user_id,
                        };

                        const addParticipant = new BlackList();
                        addParticipant
                            .addcontactblackbyuserid(data)
                            .then((response) => {
                                if (response.isSuccess === true) {
                                    toast.success(response?.message);
                                    closeModal();
                                    props.getAllContacts();
                                } else {
                                    toast.error(response?.message);
                                }
                                resetForm();
                                setSubmitting(false);
                            })
                            .catch((error) => {
                                console.error("Error adding contact:", error);
                            });
                    }}
                >
                    {({ values, setFieldValue, isSubmitting }) => (
                        <Form>
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Field name="Username">
                                            {() => (
                                                <div className="mb-3">
                                                    <label htmlFor="Username" className="form-label">
                                                        Contact Name
                                                    </label>
                                                    <TextField
                                                        fullWidth
                                                        autoComplete="off"
                                                        id="Username"
                                                        name="Username"
                                                        value={values.Username}
                                                        onChange={(e) =>
                                                            setFieldValue("Username", e.target.value)
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        inputProps={{
                                                            style: {
                                                                border: "none",
                                                                fontSize: "15px",
                                                                width: "100%",
                                                                padding: "10px",
                                                            },
                                                        }}
                                                    />
                                                    <ErrorMessage name="Username">
                                                        {(msg) => (
                                                            <div className="error" style={{ color: "red" }}>
                                                                {msg}
                                                            </div>
                                                        )}
                                                    </ErrorMessage>
                                                </div>
                                            )}
                                        </Field>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Field name="whatsappno">
                                            {() => (
                                                <div className="mb-3">
                                                    <label htmlFor="whatsappno" className="form-label">
                                                        Whatsapp Number
                                                    </label>
                                                    <TextField
                                                        fullWidth
                                                        autoComplete="off"
                                                        placeholder="Enter Phone number with country code"
                                                        id="whatsappno"
                                                        name="whatsappno"
                                                        value={values.whatsappno}
                                                        onChange={(e) =>
                                                            setFieldValue("whatsappno", e.target.value)
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        inputProps={{
                                                            style: {
                                                                border: "none",
                                                                fontSize: "15px",
                                                                width: "100%",
                                                                padding: "10px",
                                                            },
                                                        }}
                                                    />
                                                    <ErrorMessage name="whatsappno">
                                                        {(msg) => (
                                                            <div className="error" style={{ color: "red" }}>
                                                                {msg}
                                                            </div>
                                                        )}
                                                    </ErrorMessage>
                                                </div>
                                            )}
                                        </Field>
                                    </Grid>
                                </Grid>

                                <Divider sx={{ my: 2 }} />

                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Creating..." : "Create Now"}
                                        </Button>
                                    </Grid>
                                </Grid>

                                <Divider sx={{ my: 2 }} />
                            </DialogContent>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </div>
    );
};

export default AddContact;
